import AutoplayController from "~/lib/autoplay_controller"
import { money, replay, setOpen, tween } from "~/lib/motion"

// Each bundle's discount lands in the order summary, then they merge into one
export default class extends AutoplayController {
  static targets = ["discounts", "discount", "merged", "total"]
  static values = { subtotal: Number }

  reset() {
    this.discountTargets.forEach((row) => (row.hidden = true))
    this.discountsTarget.style.height = ""
    this.discountsTarget.style.opacity = ""
    this.mergedTarget.hidden = true
    this.totalTarget.textContent = money(this.subtotalValue)
  }

  async play(wait) {
    let total = this.subtotalValue
    for (const row of this.discountTargets) {
      await wait(700)
      row.hidden = false
      replay(row, "is-pop")
      const amount = Number(row.dataset.amount)
      tween(this.totalTarget, total, total - amount, 400)
      total -= amount
    }
    await wait(1100)
    setOpen(this.discountsTarget, false)
    this.discountsTarget.style.opacity = "0"
    await wait(450)
    this.mergedTarget.hidden = false
    replay(this.mergedTarget, "is-pop")
  }
}
